const manufacturerAddress = `Harscombe House,<br/>1 Darklake View,<br/>Estover,<br/>Plymouth,<br/>PL6 7TL,<br/>United Kingdom<br/>contact@primumdigital.com<br/>+447960051761`;

const responsiblePersonAddress =
  "Harscombe House,<br/>1 Darklake View,<br/>Estover,<br/>Plymouth,<br/>PL6 7TL,<br/>United Kingdom<br/>contact@primumdigital.com<br/>+447960051761";

export { manufacturerAddress, responsiblePersonAddress };
